/* eslint-disable */
import createIcon from '../createIcon';

const IconMessage = createIcon({
  name: 'icon-message',
  content: '<title>ic_消息</title><defs><rect id="icon-message-a" x="0" y="0" width="16" height="16"/></defs><g stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1075.000000, -6356.000000)"><g transform="translate(498.000000, 6169.000000)"><g transform="translate(111.000000, 187.000000)"><g transform="translate(466.000000, 0.000000)"><mask id="icon-message-b" fill="currentColor"><use xlink:href="#icon-message-a"/></mask><use fill="currentColor" opacity="0" xlink:href="#icon-message-a"/><path d="M16,1 L16,15 L0,15 L0,1 L16,1 Z M15,2.663 L7.99993838,8.65829355 L1,2.663 L1,14 L15,14 L15,2.663 Z M14.238,2 L1.764,2 L8.00006162,7.34170645 L14.238,2 Z" fill="currentColor" fill-rule="nonzero" mask="url(#icon-message-b)"/></g></g></g></g></g>',
  width: 16,
  height: 16
}, 'Icon');
export default IconMessage;
